import React from "react";
import Hero from "./Hero";
import { useGlobalContext } from "../context";
import { NavLink } from "react-router-dom";

const Home = () => {
  const { dishes } = useGlobalContext();
  const dish = dishes.find((item) => {
    return item.featured === true;
  });
  const { img, name } = dish;

  return (
    <section className="home">
      <Hero />
      <section className="home-groups">
        <div className="home-group">
          <img className="home-group-img" src={img} alt={name} />
          <div className="home-group-details">
            <p className="home-group-desc">
              We render bespoke services, we give distinctive foods to meet the
              most requesting desires and tastes. We offer unique and assorted
              food for your event gathering both local menu, oriental and
              continental dishes. Our services is not limited to Lagos but also
              to any part of the country even outside the sphere of Nigeria. Our
              service men and women are capable, competent, loyal, attractive
              and trustworthy people.
            </p>
            <NavLink className="home-group-link" to="/menu">
              Our Menu
            </NavLink>
          </div>
        </div>

        <div className="home-group">
          <img
            className="home-group-img"
            src="/images/waiter Dishing.jpg"
            alt="Waiters Dishing"
          />
          <div className="home-group-details">
            <p className="home-group-desc">
              Affordable services was established in December 2015 in Lagos. It
              is an organization that tailored cooking to suite client's desire.
              We are organisation which match the tastes of guest based on
              exceptional and hygienic food preparation. We make foods for
              events such as dinners parties, kiddies parties, office parties,
              birthday parties, school reunions, friends hangouts, funeral
              parties and wedding parties with an assortment in nourishment from
              various foods.
            </p>
            <NavLink className="home-group-link" to="/about">
              Who We Are
            </NavLink>
          </div>
        </div>

        <div className="home-group">
          <img
            className="home-group-img"
            src="/images/gallery4.jpeg"
            alt="Waiters Dishing"
          />
          <div className="home-group-details">
            <p className="home-group-desc">
              At Affordable Services, we believe that one picture will do a
              better summary of a thousand words. We have a plethora of pictures
              from past events we've covered.The pictures do not only show the
              quality of our service, it also goes a long way to depict the
              value we place on cleanliness and simplicity. Click the link below
              to see the quality of our works.
            </p>
            <NavLink className="home-group-link" to="/gallery">
              Gallery
            </NavLink>
          </div>
        </div>
      </section>
    </section>
  );
};

export default Home;
